/* utils */

function debounce(func, timeout = 300){
    let timer;
    return (...args) => {
      clearTimeout(timer);
      timer = setTimeout(() => { func.apply(this, args); }, timeout);
    };
}

/* mega menu tabs */

function switchTab(newTab) {
  if (!newTab)
    return;
  
  if (newTab.getAttribute("aria-selected") === 'true')
    return;
    
  const menu = newTab.closest(".covec-mega-menu");
  const oldTab = menu.querySelector(".covec-mega-menu__tab[aria-selected='true']");
  
  if (!menu)
    return;

  if (!oldTab)
    return;

  const tabs = Array.from(menu.getElementsByClassName("covec-mega-menu__tab"));
  const panels = menu.querySelectorAll(".covec-mega-menu__tabpanel");
  
  newTab.focus();
  newTab.removeAttribute('tabindex');
  newTab.setAttribute('aria-selected', 'true');

  oldTab.removeAttribute('aria-selected');
  oldTab.setAttribute('tabindex', '-1');

  /*
  panels[tabs.indexOf(oldTab)].hidden = true;
  panels[tabs.indexOf(newTab)].hidden = false;
  */
  
  panels[tabs.indexOf(newTab)].removeAttribute('aria-hidden');
  panels[tabs.indexOf(oldTab)].setAttribute('aria-hidden', 'true');

  const currentIndex = tabs.indexOf(newTab);

  panels.forEach((item, index) => {

    item.hidden = false;

    item.classList.remove("is-more");
    item.classList.remove("is-less");

    if (index < currentIndex) {
      panels[index].classList.add("is-less");
    } else if (index > currentIndex) {
      panels[index].classList.add("is-more");
    }
    
  });
  
}

window.addEventListener("click", (ev) => {
  const tab = ev.target.closest(".covec-mega-menu__tab");

  if (tab) {
    ev.preventDefault();
    switchTab(tab);
  }
});

window.addEventListener("mouseover", (ev) => {
  requestAnimationFrame(() => {
    const tab = ev.target.closest(".covec-mega-menu__tab");

    if (tab)
      switchTab(tab);
  });
});

function refreshTabPanelSizes() {
  const panelContainers = document.getElementsByClassName("covec-mega-menu__tabpanels");

  for (let i = 0; i < panelContainers.length; i++) {
    const panels = panelContainers[i].getElementsByClassName("covec-mega-menu__tabpanel");

    let minHeight = 0;
    for (let j = 0; j < panels.length; j++) {

      panels[j].hidden = false;
      const panelHeight = panels[j].offsetHeight;
      if (minHeight < panelHeight) {
        minHeight = panelHeight;
      }
    }

    panelContainers[i].style.minHeight = `${minHeight}px`;
  }
}

const handleMegaMenuResize = debounce(() => {
  refreshTabPanelSizes();
}, 1000);

window.addEventListener("resize", handleMegaMenuResize);

window.addEventListener("DOMContentLoaded", () => {
  refreshTabPanelSizes();
});

/* end of tabs */

/* quick add details show/hide */

  const quickAddModalContentEls = document.getElementsByClassName("quick-add-modal__content");

  function contentDialogScroll(event) {
    requestAnimationFrame(() => {
      const modal = event.target.closest('modal-dialog'),
            tableHeader = modal.querySelector("thead");
  
      if (!tableHeader) {
        return;
      }

      const contentInfo = modal.querySelector(".quick-add-modal__content-info"),
            detailsInfo = modal.querySelector(".quick-add__info-details");

      contentInfo.style.setProperty('--info-height', detailsInfo.offsetHeight + 'px');

      if (Math.round(tableHeader.getBoundingClientRect().top) - Math.round(event.target.getBoundingClientRect().top) <= 8) {
        contentInfo.classList.add("is-pinned");
      } else {
        contentInfo.classList.remove("is-pinned");
      }
    });
  }

  for (let i = 0; i < quickAddModalContentEls.length; i++) {
    const modal = quickAddModalContentEls[i].closest('modal-dialog');

    if (!modal)
      continue;

    quickAddModalContentEls[i].addEventListener("scroll", contentDialogScroll);
  }

/* end of quick add details show/hide */

/* product micro order list */

  function tableHighlight(inputEl) {

    const variantId = inputEl.getAttribute("data-quantity-variant-id");

    if (variantId === "")
      return;

    const table = inputEl.closest(".micro-order-list__table");

    if (!table || !inputEl)
      return;

    const rows = table.querySelectorAll("tr");

    for (let i = 0; i < rows.length; i++) {
      const row = rows[i],
            columns = row.querySelectorAll("td");

      for (let j = 0; j < columns.length; j++) {
        const column = columns[j],
              quantityInput = column.querySelector("[data-quantity-variant-id]");

        if (!quantityInput)
          continue;

        if (quantityInput.getAttribute("data-quantity-variant-id") == variantId) {
          const header = table.querySelectorAll("thead th")[j + 1];

          if (header) {
            const label = header.querySelector(".quick-order-list__option");

            if (!label)
              break;
            
            label.classList.add("is-highlighted");
          }

          const bodyHeader = table.querySelectorAll("tbody th")[i - 1];

          if (!bodyHeader)
            break;
          
          const bodyHeaderLabel = bodyHeader.querySelector(".quick-order-list__option");

          if (!bodyHeaderLabel)
            break;

          bodyHeaderLabel.classList.add("is-highlighted");
          
          break;
        }
      }
      
    }
    
  }

  window.addEventListener("focusin", (ev) => {
    const table = ev.target.closest(".micro-order-list__table"),
          input = ev.target.closest(".quantity__input");

    if (!table || !input)
      return;

    tableHighlight(input);
    
  });

  window.addEventListener("focusout", (ev) => {
    const table = ev.target.closest(".micro-order-list__table"),
          input = ev.target.closest(".quantity__input");

    if (!table || !input)
      return;

    const headerLabels = table.querySelectorAll(".quick-order-list__option");

    for (let i = 0; i < headerLabels.length; i++) {
      headerLabels[i].classList.remove("is-highlighted");
    }
    
  });

  function focusOnVariant() {

    let params = new URLSearchParams(document.location.search);
    let variant = params.get("variant");
  
    if (variant == null)
        return;
  
    const variantQtyInput = document.querySelector(`[data-quantity-variant-id='${variant}']`);
    if (!variantQtyInput) {
      return;
    }

    variantQtyInput.focus();

  }

  focusOnVariant();

/* end of product micro order list */

/* price switch */

  function switchToRetailPricing(bool) {
    const retailPricingEls = document.querySelectorAll("[data-retail-price]");

    for (let i = 0; i < retailPricingEls.length; i++) {
      const retailPricingEl = retailPricingEls[i],
            tradePrice = retailPricingEl.getAttribute("data-trade-price"),
            retailPrice = retailPricingEl.getAttribute("data-retail-price");

      if (bool) {
        retailPricingEl.innerHTML = retailPrice;
      } else {
        retailPricingEl.innerHTML = tradePrice;
      }
    }

    sessionStorage.setItem("retailPricing", bool);
  }

  const priceSwitchEl = document.getElementById("retail_pricing");

  if (priceSwitchEl) {
    priceSwitchEl.addEventListener("change", (ev) => {
      switchToRetailPricing(priceSwitchEl.checked);
    });
  }

  if (sessionStorage.getItem("retailPricing") == "true") {
    priceSwitchEl.checked = true;
    switchToRetailPricing(true);
  }

/* end of price switch */

/* header account */

  window.addEventListener("click", (ev) => {
    const headerAccountToggle = ev.target.closest(".header__account-toggle"),
          headerAccountPopup = ev.target.closest(".header__account-popup");

    if (!document.querySelector(".header__account-popup"))
      return;

    if (headerAccountToggle) {
      document.querySelector(".header__account-popup").classList.toggle("is-open");
    } else if (!headerAccountPopup) {
      document.querySelector(".header__account-popup").classList.remove("is-open");
    }
  })

/* end of header account */
